import { render, staticRenderFns } from "./menu_sidebar.vue?vue&type=template&id=35f4d40e&scoped=true&"
import script from "./menu_sidebar.vue?vue&type=script&lang=js&"
export * from "./menu_sidebar.vue?vue&type=script&lang=js&"
import style0 from "./menu_sidebar.vue?vue&type=style&index=0&id=35f4d40e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f4d40e",
  null
  
)

export default component.exports